<template>
    <div class="d-flex flex-fill">
        <div class="container py-3">
            <div class="row justify-content-center h-100">
                <div class="col-sm-12">
                    <div class="d-flex flex-column w-100 h-100">
                        <div class="flex-grow-1">
                            <div v-if="paymentsList.length > 0">
                                <payment-rows
                                    :payments="paymentsList"
                                    :refunds="reservation.refunds"
                                    :reservation="reservation"
                                />
                            </div>

                            <div v-else class="text-center fs-large dark w-100 my-4">
                                No Payments found
                            </div>
                        </div>
                        
                        <label v-if="reservation.isToGeneratePaymentLink || activePaymentLink && enabledStatusStripeIntegration" class="fs-large p-2">Payment Link</label>
                        
                        <div v-if="activePaymentLink && enabledStatusStripeIntegration" class="bg-lighter px-3 py-3 mb-3 mt-1 radius-normal" style="border: 1px solid rgb(197, 208, 222);list-style-type: disc;">
                            <div class="d-flex justify-content-between px-3">
                                <div class="">
                                    <div class="d-flex row">
                                        <span class="mr-4"><strong>Amount:</strong> {{formatPriceLink(activePaymentLink.value)}}€</span>
                                        <span class="mr-4" v-if="activePaymentLink.cancelBookingIfNotPaidAfter">
                                            <strong>Expires:</strong> {{formatDateDots(activePaymentLink.cancelBookingIfNotPaidAfter)}} 
                                            <strong> at </strong><span>{{formatTime(activePaymentLink.cancelBookingIfNotPaidAfter) }}</span>
                                        </span>

                                        <span class="mr-4" v-else>
                                            <strong>Expires:</strong> n/a
                                        </span>
                                        <span ><strong>Notes:</strong> {{activePaymentLink.description || 'n/a'}}</span>
                                    </div>

                                </div>

                                <div class="ml-2 d-flex align-items-start">
                                    <button 
                                        v-if="hasEmail" 
                                        class="btn bg-lightest darker text-center border-light radius-normal pointer mr-2" 
                                        :class="{ 'tab-payments__send-link--sending': isSendingLink }" 
                                        :disabled="isSendingLink" 
                                        style="white-space: nowrap;"
                                        @click="isSendingLink ? null : sendLink()"
                                    >{{ isSendingLink ? 'Sending Email' : 'Send Email' }}</button>
                                    <button v-if="activePaymentLink.canBeCancelled" class="btn blue" @click="openPaymentLinkDetails">Details</button>
                                </div>                        
                            </div>
                        </div>

                        <div v-else-if="paymentLink && paymentLink.bookingId == 0 && reservation.isToGeneratePaymentLink && enabledStatusStripeIntegration" class="bg-lighter px-3 py-3 mb-3 mt-1 radius-normal" style="border: 1px solid rgb(197, 208, 222);list-style-type: disc;">
                            <div class="d-flex align-items-center justify-content-between">
                                <span class="mx-4"><strong>Amount:</strong> {{formatPriceLink(paymentLink.value)}}€</span>
                                <span class="mr-4" v-if="paymentLink.cancelBookingIfNotPaidAfter">
                                    <strong >Expires:</strong> {{formatDateDots(paymentLink.cancelBookingIfNotPaidAfter)}} 
                                    <strong> at </strong><span>{{formatTime(paymentLink.cancelBookingIfNotPaidAfter) }}</span>
                                </span>

                                <span class="mr-4" v-else><strong>Expires:</strong> n/a</span>
                                <span class="mx-4"><strong>Notes:</strong> {{paymentLink.description ? paymentLink.description : 'n/a'}}</span>
                                <span class="mx-4 color-1"><strong>Pending</strong></span>
                                <i @click="reservation.isToGeneratePaymentLink = false" class="fa fa-times fs-large light ml-2 pointer"></i>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end mb-2">
                            <div class="d-flex align-items-center payment-legend">
                                <span class="payment-legend__dot bg-color-2"></span><span class="payment-legend__label">Legacy</span>
                                <span class="payment-legend__dot bg-color-3"></span><span class="payment-legend__label">Paid</span>
                                <span class="payment-legend__dot bg-color-5"></span><span class="payment-legend__label">Partially paid</span>
                                <span class="payment-legend__dot" style="background-color: hsl(30, 89%, 49%);"></span><span class="payment-legend__label">Partially refunded</span>
                                <span class="payment-legend__dot bg-color-6"></span><span class="payment-legend__label">Refunded</span>
                            </div>
                        </div>

                        <div class="d-flex border-top-medium justify-content-end pt-2">

                            <div class="d-flex align-items-center">
                                <button v-if="reservation.flags.canCreatePaymentLink && !activePaymentLink && !this.reservation.isToGeneratePaymentLink && enabledStatusStripeIntegration" :disabled="isReservationReadOnly && reservation.status != -5 || reservation.paymentStatus === 1 || reservation.paymentStatus === 2 && this.outstandingAmout || disabled" class="btn wider blue mr-3" @click="openReservationLinkIn()">Payment Link</button>

                                <button :disabled="!reservation.flags.payInEnabled" class="btn wider green mr-3" @click="openModal('ReservationPayIn')">Pay in</button>
                                <button
                                    :disabled="isRefundButtonDisabled"
                                    class="btn wider action"
                                    @click="createRefundBtn()"
                                    v-tooltip="isRefundButtonDisabled ? null : 'Customer and Agent (if applied) will receive an email with refund information.'"
                                >
                                    Refund <i class="fas fa-info-circle mr-0 ml-1"></i>
                                </button>
                                <div v-if="isToShowInvoicing" class="ml-3 pl-3 d-flex align-items-center tab-payments__invoice-section">
                                    <div class="mr-2" style="min-width: 150px;">
                                        <v-select 
                                            v-if="!getIsDocumentTypesLoading"
                                            :options="documentTypesOptions"
                                            label="label"
                                            :value="documentTypeSelected"
                                            :disabled="getIsSavingReservation || !getShowInvoiceOption || !documentTypeSelected || !reservation.flags.canBeInvoiced" 
                                            @input="updateDocType"
                                        />
                                    </div>

                                    <div v-if="getIsDocumentTypesLoading" class="mr-2">
                                        <loader></loader>
                                    </div>

                                    <button 
                                        :disabled="getIsSavingReservation || !getShowInvoiceOption || !documentTypeSelected || !reservation.flags.canBeInvoiced" 
                                        class="btn blue btn-height" 
                                        @click="startCreateInvoice" 
                                        v-tooltip="disableTooltip"
                                    >
                                        Create Invoice
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import { PAYMENT_STATUS } from '@/enums/paymentStatus'
import { eventHub } from '@/main'
import paymentRows from '@/tools/modal/ReservationEditV2/TabPayments/paymentRows'
import paymentLinksService from '@/api/reservation/paymentLinksService'
import extendedVSelect from '@/extends/vue-select'
import Loader from '@/tools/loaders/loader1'
import IntegrationType from '@/enums/integrationType'

export default {
    data() {
        return {
            isSendingLink: false,
            PAYMENT_STATUS,
            documentTypeSelected: null,
        }
    },
    mixins: [
        reservationsMixin,
    ],
    props:{
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    async created() {
        eventHub.$on('paymentLinks:refresh', this.handlePaymentLinkRefresh);
        
        if (this.getDocumentTypes.length === 0) {
            await this.requestDocumentTypes();
        }
        
        this.documentTypeSelected = this.getDocumentTypes.find(item => item.isDefault);
        this.setSelectedDocumentType(this.documentTypeSelected);
    },
    beforeDestroy() {
        eventHub.$off('paymentLinks:refresh', this.handlePaymentLinkRefresh);
    },
    computed: {
        ...mapGetters([
            'getReservationCalculations',
            'getSelectedReservation',
            'getIsLoadingSupplierIntegrations',
            'getSingleIntegration',
            'getAllIntegrations',
            'getIsSavingReservation',
            'getShowInvoiceOption',
            'getInvoiceSystemIntegration',
            'getIsDocumentTypesLoading',
            'getDocumentTypes',
            'getUserIntegrations'
        ]),
        isToShowInvoicing() {
            return this.getUserIntegrations && this.getUserIntegrations.some(
                integration => integration.type === IntegrationType.Invoicing
            );
        },
        documentTypesOptions() {
            return this.getDocumentTypes.filter(i => i.id !== 'PF' && i.id !== 'NC');
        },
        reservationHasPayments() {
            return this.reservation.payments && this.reservation.payments.length > 0;
        },
        disableTooltip() {
            if (!this.getShowInvoiceOption) {
                return "You have no integration with invoicing system";
            }
        },
        isRefundButtonDisabled() {
            return this.accessPermissionFilter(['restricted']) || !this.reservation.flags.canCreateGlobalRefund;
        },
        hasEmail() {
            return this.reservation.customer.email;
        },
        refundsOrPayOutAllowed() {
            return (this.paymentsList.length > 0 && this.paymentsList.some(p => p.paymentDirection === 0 && p.id !== 0));
        },
        paymentsList() {
            let payments = [];

            if (this.reservation.payments && this.reservation.payments.length > 0) {
                payments = this.reservation.payments.sort((a, b) => {
                    return moment(a.date).isAfter(moment(b.date));
                });
            }

            const merged = payments
                .concat(this.unsavedRefundsList);

            const uniqueMap = new Map();

            merged.forEach(item => {
                if (!uniqueMap.has(item.id)) {
                    uniqueMap.set(item.id, item);
                }
            });

            return Array.from(uniqueMap.values());
        },
        stripeIntegration() {
            if (this.getAllIntegrations.length > 0 && this.getIsLoadingSupplierIntegrations == false) {
                return this.getSingleIntegration(101);
            } else {
                return false;
            }
        },
        enabledStatusStripeIntegration() {
            if (this.stripeIntegration) {
                return this.stripeIntegration.integrationStatus == 1;
            } else {
                return false;
            }
        },
        activePaymentLink() {
            let pendingLink = this.reservation.bookingBillingPaymentLinks.find((link)=>{
                return link.status == 1;
            });

            return pendingLink;
        },
        paymentLink() {
            if (this.reservation.bookingBillingPaymentLink) {
                return this.reservation.bookingBillingPaymentLink;
            }
        },
        unsavedRefundsList() {
            // we need to mask it as a "payemnt" to be shown as one
            let unsavedRefunds = this.reservation.refunds.filter(refund => {
                return !refund.id;
            });

            let refundsMaskedAsPayments = unsavedRefunds.map(refund => {
                return {
                    "id": -1,
                    "date": moment().format('YYYY-MM-DD HH:mm:ss'),
                    "type": -100,
                    "paymentTypeDescription": "Unsave Refund",
                    "value": refund.amountResumeValue,
                    "currency": "€",
                    "paymentDirection": 0,
                    "paymentDirectionDescription": "Pay In",
                    "description": null,
                    "treasurerSupplier": null,
                    "treasurerUserAccount": null,
                    "treasurerChannel": null,
                    "refundId": null,
                    "refundObj": refund,
                    "isVirtualPayment": false
                }
            });

            return refundsMaskedAsPayments;
        },
        generalRefundsList() {
            if (!this.reservation.generalRefunds || this.reservation.generalRefunds.length === 0) {
                return [];
            }

            return this.reservation.generalRefunds.map(function(refund) {
                return {
                    "id": -refund.id,
                    "date": refund.date || moment().format('YYYY-MM-DD HH:mm:ss'),
                    "type": -100,
                    "paymentTypeDescription": "Refund",
                    "value": refund.amountResumeValue,
                    "currency": "€",
                    "paymentDirection": 0,
                    "paymentDirectionDescription": "Refund",
                    "description": null,
                    "treasurerSupplier": null,
                    "treasurerUserAccount": null,
                    "treasurerChannel": null,
                    "refundId": null,
                    "refundObj": refund,
                    "isVirtualPayment": false
                };
            });
        },
        hasUnsavedChanges() {
            const updateFlags = this.reservation.updateFlags;
            const hashasUnsavedChanges = Object.values(updateFlags).some(value => value === true);
            
            return hashasUnsavedChanges;
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'sendPaymentLinkByEmail',
            'setRefundPaymentId',
            'refreshCurrentSelectedReservation',
            'requestDocumentTypes',
            'setSelectedDocumentType'
        ]),
        handlePaymentLinkRefresh(updatedLink) {
            this.refreshCurrentSelectedReservation().then(() => {
                this.eventHub.$emit('updateThisReservation', this.getSelectedReservation);
            });
        },
        showUnsavedChangesAlert() {
            this.$dialog.alert(
                `<div class="d-flex flex-column justify-content-center">
                    <div class="fs-largest font-weight-600 mb-4">There are unsaved changes!</div>
                    <div class="bold dark">You must save the reservation before rebooking.</div>
                </div>`,
                { okText: 'Yes', cancelText: 'No'}
            );
        },
        openReservationLinkIn() {
            if (this.hasUnsavedChanges) {
                this.showUnsavedChangesAlert();
            } else {
                this.openModal('ReservationLinkIn');
            }
        },
        openPayOutModal() {
            if (this.hasUnsavedChanges) {
                this.showUnsavedChangesAlert();
            } else {
                this.openModal('ReservationPayOut');
            }
        },
        outstandingAmout() {
            return this.getReservationCalculations.grandTotal;
        },
        createRefundBtn() {
            if (this.hasUnsavedChanges) {
                this.showUnsavedChangesAlert();
                return;
            }
            this.setRefundPaymentId(null);
            this.eventHub.$emit('refundReservation');
        },
        changeStatusLink() {
            let pendingLink = this.reservation.bookingBillingPaymentLinks.find((link) => {
                return link.status == 1;
            });
            this.$set(this.getSelectedReservation.updateFlags, 'paymentLink', true);
            pendingLink.status = 3;
        },
        async openPaymentLinkDetails() {
            const result = await paymentLinksService.getPaymentLink(this.activePaymentLink.id);
            if (!result.ok) return;

            const payload = { ...result.value, reservation: "#"+this.reservation.id };

            this.openModal('PaymentLinkDetails');

            this.$nextTick(() => {
                eventHub.$emit('paymentLinks:detailsLoaded', payload);
            });
        },
        formatPriceLink(price) {
            let rounded = Math.round(price * 100) / 100;
            
            return parseFloat(rounded).toFixed(2);
        },
        copyUrl(url) {
            let urlLink = url;
            this.$clipboard(urlLink);
            this.$toasted.success('Url copied');
        },
        sendLink() {
            if (this.isSendingLink) {
                return;
            }

            this.isSendingLink = true;
            this.$toasted.info(`Sending to ${this.reservation.customer.email}`);

            this.sendPaymentLinkByEmail().then(result => {
                if (result) {
                    this.$toasted.success('Your email has been sent.');
                } else {
                    this.$toasted.error('Something went wrong, please try again later.');
                }
            })
            .catch(() => {
                this.$toasted.error('Something went wrong, please try again later.');
            })
            .finally(() => {
                this.isSendingLink = false;
            });
        },
        updateDocType(event) {
            this.setSelectedDocumentType(event);
        },
        startCreateInvoice() {
            if (this.reservationHasUnsavedChanges) {
                this.$dialog.alert(
                    `<div class="d-flex flex-column justify-content-center">
                        <div class="fs-largest font-weight-600 mb-4">There are unsaved changes!</div>
                        <div class="bold dark">You must save the reservation before invoicing.</div>
                    </div>`,
                    { okText: 'Yes', cancelText: 'No' })

                return false;
            }

            this.eventHub.$emit('editReservation_toggleCreateInvoice');
        },
    },
    components: {
        paymentRows,
        vSelect: extendedVSelect,
        Loader,
    }
}
</script>

<style lang="scss" scoped>
    .btn-height {
        height: 39px;
    }

    .tab-payments__send-link--sending {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .tab-payments__invoice-section {
        border-left: 1px solid rgb(197, 208, 222);
    }

    .payment-legend {
        gap: 0.5rem;
        font-size: 0.75rem;
        color: #6c757d;

        &__dot {
            display: inline-block;
            width: 0.65rem;
            height: 0.65rem;
            border-radius: 50%;
            flex-shrink: 0;
        }

        &__label {
            white-space: nowrap;
        }
    }
</style>


// WEBPACK FOOTER //
// TabPayments.vue?39ad5106